import SingleModelInterface from '../../types/singleModelInterface'
import CustomerTypes from '../customerTypes/customerTypes'

export default function filterByCustomerType(
    customerType: CustomerTypes,
    allCars: SingleModelInterface[]
): SingleModelInterface[] {
    return allCars.filter((model) => {
        const customerTypesFromEnum = Object.values(CustomerTypes)

        if (!customerType || !customerTypesFromEnum.includes(customerType)) {
            return allCars
        }
        const customerTypesFromPromos = model.related_promotions.map(
            (promo) => promo.customer_type
        )

        return customerTypesFromPromos.includes(customerType)
    })
}
